import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { atLeastOneRequiredTrueValidator } from "../../../custom-validators/at-least-one-is-required-true-validator";
import { DropDownModel } from "../../../domain/model/common/dropDownModel";
import { GooglePlacesService } from "../../../domain/service/GooglePlaceService";

@Component({
  selector: "app-reporting-form",
  templateUrl: "./reporting-form.component.html",
  styleUrl: "./reporting-form.component.css",
})
export class ReportingFormComponent implements OnInit {
  @Input() rentalPropertyReporting!: FormGroup;
  constructor(private googlePlacesService: GooglePlacesService) {}

  showTaxRepresentativeForm: boolean = false;

  suggestions: any[] = [];
  @Input() states: DropDownModel[] = [];

  ngOnInit(): void {
    this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.valueChanges.subscribe((value) => {
      if (value) {
        this.googlePlacesService.getPlaces(value).then((predictions: any) => {
          this.suggestions = predictions;
        });
      } else {
        this.suggestions = [];
      }
    });
    this.rentalPropertyReporting.get("isUsingTaxRepresentative")?.setValue(null);

    this.rentalPropertyReporting.get("isUsingTaxRepresentative")?.valueChanges.subscribe((value) => {
      this.showAndHideTaxForm(value);
    });
  }
  public showAndHideTaxForm(show: boolean) {
    if (show) {
      this.rentalPropertyReporting.get("taxRepresentativeFirstName")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeFirstName")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeLastName")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeLastName")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeEmail")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeEmail")?.addValidators(Validators.email);
      this.rentalPropertyReporting.get("taxRepresentativeEmail")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativePhoneNumber")?.addValidators(Validators.required);
      this.rentalPropertyReporting
        .get("taxRepresentativePhoneNumber")
        ?.addValidators(
          Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
        );
      this.rentalPropertyReporting.get("taxRepresentativePhoneNumber")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeCity")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeCity")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeState")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeState")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.addValidators(Validators.required);
      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.addValidators(Validators.maxLength(12));
      this.rentalPropertyReporting
        .get("taxRepresentativeZipCode")
        ?.addValidators(Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/));
      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.updateValueAndValidity();

      this.rentalPropertyReporting.setValidators(atLeastOneRequiredTrueValidator("sendToOwner", "sendToReportingRep"));
      this.rentalPropertyReporting.updateValueAndValidity();
    } else {
      this.rentalPropertyReporting.get("taxRepresentativeFirstName")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeFirstName")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeLastName")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeLastName")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeEmail")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeEmail")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativePhoneNumber")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativePhoneNumber")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeStreetAddress")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeCity")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeCity")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeState")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeState")?.updateValueAndValidity();

      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.clearValidators();
      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.updateValueAndValidity();

      this.rentalPropertyReporting.clearValidators();
    }
    this.showTaxRepresentativeForm = show;
  }
  async selectPlace(place: any) {
    console.log(place);

    this.suggestions = [];
    const details = await this.googlePlacesService.getPlaceDetails(place.place_id);
    let selectedZipCode = this.googlePlacesService.extractLocationDetails(details);

    if (selectedZipCode.zip) {
      this.rentalPropertyReporting.get("taxRepresentativeZipCode")?.setValue(selectedZipCode.zip);
    }

    if (selectedZipCode.city) {
      this.rentalPropertyReporting.get("taxRepresentativeCity")?.setValue(selectedZipCode.city);
    }

    if (selectedZipCode.stateCode) {
      let stateId = this.states.find((e) => e.iso2 == selectedZipCode.stateCode)?.id ?? 0;
      console.log(stateId.toString());
      this.rentalPropertyReporting.get("taxRepresentativeState")?.setValue(stateId);
    }

    if (selectedZipCode.address) {
      this.rentalPropertyReporting?.get("taxRepresentativeStreetAddress")?.setValue(selectedZipCode.address);
      this.rentalPropertyReporting?.get("taxRepresentativeStreetAddress")?.updateValueAndValidity();
      this.rentalPropertyReporting?.get("taxRepresentativeStreetAddress")?.markAsUntouched();
    }
  }
}
